<script>
    import { Arrow } from '../../index'
    let cls = "sui-form-item";
    export let label = "";
    export let id = "";
    export let clickable = false;
</script>

<div class={cls}>
    {#if label}
        <label class={`${cls}-label`} for={id}>{label}</label>
    {/if}
    <div class={`${cls}-inner`}>
        <slot><!-- optional fallback --></slot>
        {#if clickable}
             <div class={`${cls}-arrow`}>
                <Arrow size={20}/>
             </div>
        {/if}
    </div>
</div>

<style lang="less">
    @import './form.less';
</style>
